import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'
import Policy from 'modules/payroll_bundle/store/models/Policy'

import DeletePolicyModal from './DeletePolicyModal'

interface Props {
  canEdit: boolean
  payrollPolicy: Policy
}

const Item = ({ canEdit, payrollPolicy }: Props) => {
  const { setContractVersionPolicy, setCompensations, compensations } = useContractFlow()
  const [showDeleteModal, setShowDeleteModal] = React.useState(false)

  const compensationsWithPolicyCount = () => {
    return compensations.filter((c) => c.attributes.sync_with_supplements).length
  }

  const removePayrollPolicy = () => {
    if (compensationsWithPolicyCount() > 0) setShowDeleteModal(true)
    else confirmPolicyRemoval()
  }

  const confirmPolicyRemoval = () => {
    setContractVersionPolicy(null)

    const compensationsWithoutPolicy = compensations.filter(
      (c) => !c.attributes.sync_with_supplements
    )
    setCompensations(compensationsWithoutPolicy)
    if (showDeleteModal) setShowDeleteModal(false)
  }

  return (
    <>
      <Box
        background="grey200"
        paddingY="s16"
        paddingX="s32"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Box gap="s2">
          <Text.Normal color="grey800" weight="medium" size="300" capitalize>
            {i18n.t('contract_versions.flows.fix.steps.legal_and_extras.payroll_policies.title', {
              policy_name: payrollPolicy.attributes.name,
            })}
          </Text.Normal>
          <Box flexDirection="row" gap="s2">
            <Text.Normal color="grey800" weight="medium" size="200">
              {Policy.periodicityByRecurrence(payrollPolicy.attributes.recurrence)?.label}
            </Text.Normal>
            <Text.Normal color="grey800" weight="normal" size="200">
              {i18n.t(
                'contract_versions.flows.fix.steps.legal_and_extras.payroll_policies.starting_on',
                {
                  date: dateToString(moment(payrollPolicy.attributes.starts_on), 'ui'),
                }
              )}
            </Text.Normal>
          </Box>
        </Box>
        {canEdit && (
          <Box>
            <PopoverMenu type="list">
              <PopoverMenu.Trigger>
                <Button type="secondary" iconName="ellipsis" />
              </PopoverMenu.Trigger>
              <PopoverMenu.Content side="bottom" align="center">
                <PopoverMenu.TouchableOption
                  onClick={() => removePayrollPolicy()}
                  title={i18n.t('contract_versions.forms.payroll_policy.remove')}
                />
              </PopoverMenu.Content>
            </PopoverMenu>
          </Box>
        )}
      </Box>
      {showDeleteModal && (
        <DeletePolicyModal
          compensationsCount={compensationsWithPolicyCount()}
          onCloseModal={() => setShowDeleteModal(false)}
          onConfirm={confirmPolicyRemoval}
        />
      )}
    </>
  )
}

export default observer(Item)
